"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SITE_COMMENT_MAX_LEVEL = void 0;
exports.mapSiteCommentRaw = mapSiteCommentRaw;
exports.mapSiteCommentsRaw = mapSiteCommentsRaw;
exports.finalizeSiteComments = finalizeSiteComments;
const news_1 = require("../models/news");
const mapper_1 = require("./mapper");
/** Максимальная глубина вложенности (Android k1.a.t0.length − 1). */
exports.SITE_COMMENT_MAX_LEVEL = 9;
/**
 * Сырой комментарий из sa[13] / sl[1].
 * Заглушка `[0]` (удалённый родитель) — один элемент с id=0.
 */
function mapSiteCommentRaw(raw) {
    if (!Array.isArray(raw) || raw.length === 0)
        return null;
    const id = typeof raw[0] === 'number' ? raw[0] : 0;
    if (id === 0 && raw.length < 9) {
        return {
            id: 0,
            date: '',
            level: 0,
            flags: news_1.CommentFlags.DELETED,
            userId: 0,
            userName: '',
            text: '',
            likes: 0,
        };
    }
    if (raw.length < 9)
        return null;
    const flags = typeof raw[2] === 'number' ? raw[2] : 0;
    return {
        id,
        date: mapper_1.PdaMapper.safeIsoDate(raw[1]),
        level: 0,
        flags,
        userId: typeof raw[3] === 'number' ? raw[3] : 0,
        userName: typeof raw[4] === 'string' ? raw[4] : String(raw[4] ?? ''),
        replyToId: typeof raw[5] === 'number' && raw[5] !== 0 ? raw[5] : undefined,
        text: typeof raw[6] === 'string' ? raw[6] : String(raw[6] ?? ''),
        likes: typeof raw[7] === 'number' ? raw[7] : 0,
        avatarUrl: typeof raw[8] === 'string' ? raw[8] : undefined,
    };
}
function mapSiteCommentsRaw(rows) {
    const comments = [];
    for (const row of rows) {
        const mapped = mapSiteCommentRaw(row);
        if (mapped)
            comments.push(mapped);
    }
    return finalizeSiteComments(comments);
}
/**
 * Дерево по replyToId + DFS-развёртка (ForPDA ArticleParser / сайт).
 * Порядок детей — как в wire-массиве.
 */
function finalizeSiteComments(comments) {
    if (comments.length === 0)
        return comments;
    const byId = new Map();
    for (const c of comments) {
        if (!byId.has(c.id))
            byId.set(c.id, c);
    }
    /** parentId -> дети (wire-порядок). Только явный replyToId, без слияния с 0. */
    const childrenOf = new Map();
    for (const c of comments) {
        const parentId = c.replyToId;
        if (parentId == null || parentId === 0 || parentId === c.id)
            continue;
        let list = childrenOf.get(parentId);
        if (!list) {
            list = [];
            childrenOf.set(parentId, list);
        }
        list.push(c);
    }
    const isRoot = (c) => {
        const parentId = c.replyToId;
        if (parentId == null || parentId === 0)
            return true;
        return !byId.has(parentId);
    };
    const flattened = [];
    const seen = new Set();
    const flatten = (c, level) => {
        if (seen.has(c.id))
            return;
        seen.add(c.id);
        flattened.push({
            ...c,
            level: Math.min(level, exports.SITE_COMMENT_MAX_LEVEL - 1),
        });
        const children = childrenOf.get(c.id);
        if (!children)
            return;
        for (const child of children) {
            flatten(child, level + 1);
        }
    };
    for (const c of comments) {
        if (!isRoot(c) || seen.has(c.id))
            continue;
        flatten(c, 0);
    }
    for (const c of comments) {
        if (!seen.has(c.id)) {
            flattened.push({ ...c, level: chainDepth(c, byId) });
        }
    }
    return flattened;
}
function chainDepth(comment, byId) {
    let depth = 0;
    let parentId = comment.replyToId;
    const visited = new Set();
    while (parentId != null && parentId !== 0 && depth < exports.SITE_COMMENT_MAX_LEVEL - 1) {
        if (visited.has(parentId))
            break;
        visited.add(parentId);
        depth += 1;
        parentId = byId.get(parentId)?.replyToId;
    }
    return depth;
}
